import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {}
